import { useParams } from 'react-router-dom';
import { WavelightsContainer } from './styles';
import TechniqueCalculation from '../components/TechniqueCalculation';
import TechniquesTable from '../components/TechniquesTable';

const WavelightsWavesTechniques = () => {
  const { wid } = useParams();

  return (
    <WavelightsContainer>
      <TechniqueCalculation wid={wid || ''} />
      <TechniquesTable wid={wid || ''} />
    </WavelightsContainer>
  );
};

export default WavelightsWavesTechniques;
